import { VehicleList } from "@/components/vehicles/VehicleList";
import { useAuth } from "@/hooks/useAuth";

export default function VehiclesPage() {
  const { user } = useAuth();

  return (
 <div className="page-container">
      <VehicleList userId={user?.id} />
    </div>
  );
}
